import "./AppLayout.css";

import { Layout } from "antd";
import React, { useEffect, useState } from "react";

import { useWindowDimension } from "../../_hooks";
import { Header, Sidebar, SidebarDrawer } from "./_components";

const { Content } = Layout;

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { width } = useWindowDimension();

  useEffect(() => {
    if (width < 1023 && !collapsed) {
      setCollapsed(true);
    }
  }, [width]);

  return (
    <Layout className="mainLayout">
      <div className="sidebarWrapper">
        <Sidebar collapsed={false} setCollapsed={setCollapsed} smallLogo />
      </div>
      <SidebarDrawer open={drawerOpen} setOpen={setDrawerOpen} />

      <Layout className="mainInnerLayout">
        <Header setDrawer={setDrawerOpen} />
        <Content className="mainContent">{children}</Content>
      </Layout>
    </Layout>
  );
};
